import React, { useState } from "react";
import { ErrorMessage, Field, useField } from "formik";
import Lottie from "lottie-react";
import DotAnimation from "../../assets/images/DotAnimation.json";
import axios from "axios";
import { Img } from "../Img/index";
import { renderBaseUrlForApi } from "../../utils/index";

const TextArea: ({
    label,
    required,
    backgroundColor,
    name,
    placeHolder,
    rows,
    cols,
    customHeight,
    labelClassNames,
    disabled,
    autoGenerate,
    generate
}: {
    label?: string;
    required?: boolean;
    backgroundColor?: string;
    name: string;
    placeHolder?: string;
    rows?: number;
    cols?: number;
    customHeight?: string;
    disabled?: boolean;
    labelClassNames?: string;
    autoGenerate?: boolean;
    generate?: object;
}) => React.JSX.Element = ({
    label,
    required,
    backgroundColor,
    name,
    placeHolder,
    rows = 4,
    cols = 50,
    customHeight,
    labelClassNames,
    disabled,
    autoGenerate = false,
    generate = {}
}) => {
        const [field, meta, helpers] = useField(name);
        const [isLoading, setIsLoading] = useState(false);
        const [showInitialUI, setShowInitialUI] = useState(autoGenerate); // State to track initial UI

        const isError = meta.touched && meta.error;

        // Handle refresh button click
        const handleRefresh = async (form) => {
            try {
                setIsLoading(isLoading => true);
                const response = await axios.post(`${renderBaseUrlForApi()}/master/textGenerate`, generate);
                form.setFieldValue(name, response?.data?.data?.text);
                setIsLoading(isLoading => false);
                setShowInitialUI(showInitialUI => false);
            } catch (err) {
                setIsLoading(isLoading => false);
            }
        };


        return (
            <div className="flex flex-col gap-1">
                <div className="flex justify-between items-center">
                    {!!label && (
                        // <label
                        //     htmlFor={name}
                        //     style={{ fontSize: `12px` }}
                        //     className={`block ${labelClassNames || ""}`}
                        // >
                        //     {label} {!!required && <span className="text-red-500">*</span>}
                        // </label>
                        <label className={`block text-[1.8vh] font-medium text-gray-700 ${labelClassNames || ""}`}>
                            {label} {!!required && <span className="text-red-500">*</span>}
                        </label>)}
                    <span><ErrorMessage name={name} component="div" className="text-red-500 text-xs" /></span>
                </div>
                <div
                    style={{ backgroundColor: backgroundColor || "white" }}
                    className={`w-full border border-solid ${isError ? "border-red-500" : "border-gray-300"} rounded-md py-1 px-2 relative`}
                >
                    {isLoading && (
                        <div
                            className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10"
                            style={{ height: customHeight || "auto" }}
                        >
                            <Lottie animationData={DotAnimation} style={{ width: 90, height: 100 }} />
                        </div>
                    )}
                    <Field name={name}>
                        {({ field, form, meta }) => (
                            showInitialUI ? <div className="p-4">
                                <div className="flex justify-center items-center mb-4">
                                    <button disabled={disabled} type="button" onClick={() => handleRefresh(form)} className="bg-[#5E4DE0] rounded-full p-2">
                                        <Img src="/images/new-landing-page/descriptionImage.svg" alt="description" className="w-8 h-8 object-contain" />
                                    </button>
                                </div>
                                <p className="text-center text-[1.6vh] text-gray-500">
                                    Fill above details our AI will generate content for you
                                </p>
                            </div> : <div className="relative">
                                <textarea
                                    disabled={disabled}
                                    id={name}
                                    className={`rounded-2xl w-full py-2 px-2 text-gray-800 text-[1.8vh] sm:text-base md:text-[1.8vh] ${!!disabled ? "cursor-not-allowed" : ""}`}
                                    placeholder={placeHolder || ""}
                                    rows={rows}
                                    cols={cols}
                                    style={{
                                        backgroundColor: backgroundColor || "white",
                                        height: customHeight || "auto",
                                        padding: `calc(${customHeight} / 8)`,
                                        fontSize: `1.8vh`,
                                        resize: "none", // Disable the resize handle
                                    }}
                                    required={required}
                                    value={field.value}
                                    onChange={(event) => form.setFieldValue(name, event.target.value)}
                                />
                                {Boolean(!disabled && autoGenerate) && (
                                    <button
                                        type="button"
                                        onClick={() => handleRefresh(form)}
                                        className="absolute top-1 right-1 bg-[#5E4DE0] rounded-full p-1"
                                        style={{ zIndex: 1, top: customHeight ? `calc(${customHeight} / 2 - 16px)` : "0.25rem" }}
                                        title="Generate Text"
                                    >
                                        {/* <img src={"/images/TextGenrator.svg"} className="w-7 h-7" alt="asdasd" /> */}
                                        <Img src="/images/new-landing-page/descriptionImage.svg" alt="description" className="w-[2.5vh] h-[2.5vh] object-contain" />
                                    </button>)}
                            </div>
                        )}
                    </Field>
                </div>
            </div>
        );
    };

export default TextArea;